import { Fragment, useMemo } from "react";

import Image from "components/ui/image";
import Slider from "components/ui/slider";

import { GAME_TYPE } from "constants/game.constants";
import { binaryToFlags } from "utils/binaryCalculations";
import { buildPathToStaticFolderOfCDN, mergeClassNames } from "utils/common";

import { SLIDE_TO_SHOW } from "./constants";

import "./styles/index.scss";

const BonusGameCards = ({ gameType, isMobile, isTablet }) => {
	const includedGameTypes = useMemo(() => {
		const allGames = Object.values(GAME_TYPE);
		const _includedGameTypes = binaryToFlags(allGames, gameType);
		return _includedGameTypes;
	}, [gameType]);

	const slideToShow = isMobile ? SLIDE_TO_SHOW.MOBILE : isTablet ? SLIDE_TO_SHOW.TABLET : SLIDE_TO_SHOW.WEB;
	const infinite = slideToShow < includedGameTypes.length;
	const autoplay = slideToShow < includedGameTypes.length;

	return (
		<div className="vs--bonus-game-cards">
			<Slider
				settings={{
					className: "center",
					slidesToScroll: 1,
					infinite: infinite,
					autoplay: autoplay,
					autoplaySpeed: 1200,
					dots: false,
					draggable: autoplay,
					slidesToShow: slideToShow,
				}}
				className={mergeClassNames(!autoplay && "vs--bonus-game-cards-static-slider")}
				slideElementWrapperClassName="vs--bonus-game-card"
				items={includedGameTypes.map((gameType) => {
					return (
						<Fragment key={gameType}>
							<Image
								className="vs--bonus-game-card-info-img"
								src={buildPathToStaticFolderOfCDN(`images/bonus-banners/games/${gameType}.webp`)}
								alt="game"
							/>
						</Fragment>
					);
				})}
			/>
		</div>
	);
};
export default BonusGameCards;
